<mat-card class="decoration-card">
    <mat-card-content>
        <mat-toolbar *ngIf="!isReadonly">
            <button mat-icon-button class="crud_action" matTooltip="update" (click)="updateTrailCondition()" [disabled]="!isContentChanged" *ngIf="!isReadonly">
                <mat-icon>save</mat-icon>
            </button>

            <span class="example-spacer"></span>

        </mat-toolbar>

        <form class="example-form" (change)="onContentChange()">
            <mat-form-field class="example-full-width" [appearance]="fieldAppearance">
                <mat-label>Location</mat-label>
                <textarea matInput type="text" name="location" [(ngModel)]="trailCondition.location"
                    [readonly]="isReadonly"></textarea>
            </mat-form-field>

            <mat-form-field class="example-full-width" [appearance]="fieldAppearance">
                <mat-label>Weather</mat-label>
                <input matInput type="text" name="weather" [(ngModel)]="trailCondition.weather" [readonly]="isReadonly">
            </mat-form-field>

            <mat-form-field class="example-full-width" [appearance]="fieldAppearance">
                <mat-label>Sea state</mat-label>
                <input matInput type="text" name="sea_state" [(ngModel)]="trailCondition.sea_state"
                    [readonly]="isReadonly">
            </mat-form-field>


            <table class="example-full-width" cellspacing="0">
                <tr>
                    <td><mat-form-field class="example-full-width" [appearance]="fieldAppearance">
                            <mat-label>Water depth</mat-label>
                            <input matInput type="text" name="water_depth" [(ngModel)]="trailCondition.water_depth"
                                [readonly]="isReadonly">
                        </mat-form-field></td>
                    <td><mat-form-field class="example-full-width" [appearance]="fieldAppearance">
                            <mat-label>Sea current</mat-label>
                            <input matInput type="text" name="sea_current" [(ngModel)]="trailCondition.sea_current"
                                [readonly]="isReadonly">
                        </mat-form-field></td>
                </tr>
            </table>

            <mat-form-field class="example-full-width" [appearance]="fieldAppearance">
                <mat-label>Limitations</mat-label>
                <textarea matInput type="text" name="limitations" [(ngModel)]="trailCondition.limitations"
                    [readonly]="isReadonly"></textarea>
            </mat-form-field>

            <mat-form-field class="example-full-width" [appearance]="fieldAppearance">
                <mat-label>Remark</mat-label>
                <textarea matInput type="text" name="remarks" [(ngModel)]="trailCondition.remarks"
                    [readonly]="isReadonly"></textarea>
            </mat-form-field>

        </form>

    </mat-card-content>
</mat-card>